/**
 * Resolve chat media URLs for display (blob, absolute http(s), or API-relative paths).
 */
export const resolveMediaUrl = (rawUrl, apiBase = process.env.REACT_APP_API_BASE_URL) => {
    if (!rawUrl) return null;
    const value = String(rawUrl).trim();
    if (
        value.startsWith("blob:") ||
        value.startsWith("http://") ||
        value.startsWith("https://")
    ) {
        return value;
    }
    const base = apiBase || "";
    return `${base}${value.startsWith("/") ? value : `/${value}`}`;
};

export const revokeBlobUrl = (url) => {
    if (url?.startsWith("blob:")) {
        try {
            URL.revokeObjectURL(url);
        } catch (_) {
            /* ignore */
        }
    }
};
